import {
  type RouteObject,
} from "react-router";
import { TemplateSettingsMenuPage } from "SettingsMenuPage/SettingsMenuPage";

declare let viewModel: any;

export const templateSettingsRoute: RouteObject = {
  path: "templatesettings",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: TemplateSettingsMenuPage,
  }]
};